<template>
  <v-navigation-drawer v-model="drawer" app class="yellow lighten-5">
    <v-img
        height="140"
        class="pa-4"
        src="https://preview.pixlr.com/images/800wm/1439/2/1439104804.jpg"
    >
      <div class="text-center">
        <v-avatar class="mb-4" color="green darken-1" size="64">A
<!--          <v-img-->
<!--              aspect-ratio="30"-->
<!--              src="https://yt3.ggpht.com/esazPAO03T0f0vKdByJvkDy6MSwjyG5f-c_2S2CJapszQ3KPQyZarpoqvgv0Us0atUbILytj=s88-c-k-c0x00ffffff-no-rj"-->
<!--          />-->
        </v-avatar>
        <h2 class="white--text">Politik<span class="pink--text">.sms</span></h2>
      </div>
    </v-img>
    <v-divider></v-divider>
    <v-list>
      <v-list-item v-for="[icon, text,to] in links"  :key="icon" link @click="$router.push({name:to})" exact>
        <v-list-item-icon>
          <v-icon>{{ icon }}</v-icon>
        </v-list-item-icon>

        <v-list-item-content>
          <v-list-item-title>{{ text }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
export default {
  name: "ClientSidebar",
  props: ["drawer"],
  data() {
    return {
      links: [
        ["mdi-microsoft-windows", "Dashboard",'ClientDashboard'],
        // ["mdi-bullhorn", "Polls",''],
        // ["mdi-cog", "System Setting",""],
      ],
    };
  },
};
</script>

<style scoped></style>
